export default {
    init() {
        const className = 'tabs-block';
        const tabBtns = document.querySelectorAll('.' + className + '__btn');
        const classNameActiveTab = 'tabs-content__item--active';
        const tabSelects = document.querySelectorAll('.' + className + '__select');

        function activeBtn(){
            if (this.classList.contains(className + '__btn--active')) return;
            const activeId = this.getAttribute('data-id');
            const parent = this.closest('.tabs');

            parent.querySelector('.' + className + '__btn--active').classList.remove(className + '__btn--active');
            this.classList.add(className + '__btn--active');
            activeTab(parent, activeId)
            activeSelect(parent, activeId)
        }

        function activeSelect(parent, activeId){
            const options = parent.querySelectorAll('.' + className + '__select option');
            options.forEach(option=> {
                if(option.getAttribute('data-id') == activeId && !option.selected) {
                    option.selected = true;
                }
            })
        }

        function activeTab(parent, activeId) {
            parent.querySelector('.' + classNameActiveTab).classList.remove(classNameActiveTab);
            document.getElementById(activeId).classList.add(classNameActiveTab);
            console.log('test')
          $('.js-product-card-slider__slick').slick('refresh')
        }

        function selectChange() {
            const activeId = this.options[this.selectedIndex].getAttribute('data-id');

            const parent = this.closest('.tabs');
            parent.querySelector('.' + className + '__btn--active').classList.remove(className + '__btn--active');
            const btns = parent.querySelectorAll('button[data-id]');
            btns.forEach(btn => {
                if(btn.getAttribute('data-id') == activeId) {
                    btn.classList.add(className + '__btn--active')
                }
            })

            const options = parent.querySelectorAll('.' + className + '__select option');
            options.forEach(option=> {
                if(option.getAttribute('data-id') == activeId && !option.selected) {
                    option.selected = true;
                }
            })
            activeTab(parent, activeId)
        }

        tabBtns.forEach(btn => {
            btn.addEventListener('click', activeBtn)
        })

        tabSelects.forEach(select => {
            select.addEventListener('change', selectChange)
        })
    },
}



// WEBPACK FOOTER //
// ./scripts/components/tabFunction.js